import React from 'react';
import {FormattedMessage} from "react-intl";
import {useCustomerDetailsUIContext} from "../CustomerDetailsUIContext";
import {PopupCreatePaymentLinkProvider} from "../PopupCreatePaymentLinkContext";
import PopupCreateDocument from "../PopupCreateDocument";
import Empty from "../../../_common/components/Empty";
import PopupCreatePaymentLink from "../PopupCreatePaymentLink";
import {documentTypes as T} from "../../constants/documentTypes";
import {TextSuggestionsProvider} from '../../../_common/contexts/TextSuggestionsContext';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import Unit from '../../../_common/components/Unit';
import {getDocumentTypeData} from '../../utils/getDocumentTypeData';
import moment from 'moment/moment';
import classnames from 'classnames';
import {getStatusName} from '../../utils/getStatusName';
import PopupPreviewDocument from '../PopupPreviewDocument';
import {downloadFile} from '../../../../../utils/downloadFile';
import ButtonAction from '../../../_common/components/ButtonAction';
import Spinner from '../../../_common/components/Spinner';
import styles from "./styles.module.scss";
import themeStyles from "../../../_common/styles/theme.module.scss";
import ButtonDD from "../../../_common/components/ButtonDD";
import {useGlobalContext} from "../../../_common/contexts/GlobalContext";

const TabDocuments = () => {
  const prefix = 'customer-details-documentInfo-label-button-create';
  const {documentsData, loading} = useCustomerDetailsUIContext();
  const {isGlassTheme} = useGlobalContext();

  return loading ? <Spinner customContainerStyles={'d-flex justify-content-center'}/> : (
    <TextSuggestionsProvider>
      <div className={styles.createDocsContainer}>
        <PopupCreateDocument
          title={<FormattedMessage id={`${prefix}-100`} defaultMessage="Create work order"/>}
          documentType={T.WORK_ORDER} buttonVariant={'error'}
          icon={'/media/common/Order_white.svg'}
        />
        <PopupCreateDocument
          title={<FormattedMessage id={`${prefix}-300`} defaultMessage="Create transaction account"/>}
          documentType={T.TRANSACTION_ACCOUNT} buttonVariant={'primary'}
          icon={'/media/common/Transaction-account_white.svg'}
        />
        <PopupCreateDocument
          title={<FormattedMessage id={`${prefix}-305`} defaultMessage="Create invoice"/>}
          documentType={T.INVOICE} buttonVariant={'warning'}
          icon={'/media/common/Invoice_white.svg'}
        />
        <PopupCreateDocument
          title={<FormattedMessage id={`${prefix}-400`} defaultMessage="Create receipt"/>}
          documentType={T.RECEIPT} buttonVariant={'secondary'}
          icon={'/media/common/Receipt_white.svg'}
        />
        <PopupCreateDocument
          title={<FormattedMessage id={`${prefix}-320`} defaultMessage="Create transaction account"/>}
          documentType={T.INVOICE_RECEIPT} buttonVariant={'navy'}
          icon={'/media/common/Invoice-receipt_white.svg'}
        />
        <PopupCreatePaymentLinkProvider>
          <PopupCreatePaymentLink/>
        </PopupCreatePaymentLinkProvider>
      </div>
      <div className={styles.tabCustomerDocumentsContainer}>
        {documentsData.length > 0
          ? (
            <Unit
              icon={'/media/common/Folder_green.svg'}
              text={<FormattedMessage id={'customer-details-documents'} defaultMessage="Documents"/>}
            >
              <div className={classnames(styles.header,
                isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
                isGlassTheme ? themeStyles.primaryBackground : themeStyles.usualBackground
              )}>
                <div className={styles.headerCell}>
                  <FormattedMessage id={'customer-details-documentInfo-label-number'} defaultMessage="Number"/>
                </div>
                <div className={styles.headerCell}>
                  <FormattedMessage id={'customer-details-documentInfo-label-documentDate'} defaultMessage="Date"/>
                </div>
                <div className={styles.headerCell}>
                  <FormattedMessage id={'customer-details-documentInfo-label-type'} defaultMessage="Type"/>
                </div>
                <div className={styles.headerCell}>
                  <FormattedMessage id={'customer-details-documentInfo-label-description'}
                                    defaultMessage="Description"/>
                </div>
                <div className={styles.headerCell}>
                  <FormattedMessage id={'customer-details-documentInfo-label-amount'} defaultMessage="Amount"/>
                </div>
                <div className={styles.headerCell}>
                  <FormattedMessage id={'customer-details-documentInfo-label-status'} defaultMessage="Amount"/>
                </div>
                <div className={styles.headerCell}/>
              </div>
              <div className={styles.documentsContainer}>
                {documentsData.map((item, ind) => (
                  <div key={ind} className={styles.row}>
                    <div className={styles.cell}>
                      {item?.number}
                    </div>
                    <div
                      className={classnames(styles.cell, 'badge', 'text-dark-75 font-weight-bolder font-size-lg text-nowrap')}>
                      <div className={styles.dateCell}>
                        {item?.documentDate ? moment(item?.documentDate).format('DD-MM-YYYY') : ''}
                      </div>
                    </div>
                    <div className={styles.cell}>
                      <div className={'d-inline-block mr-2'}>
                        {getDocumentTypeData(item?.type, item.id).icon}
                      </div>
                      {getDocumentTypeData(item?.type, item?.id).typeName}
                    </div>
                    <div className={styles.cell}>
                      {item?.description}
                    </div>
                    <div className={styles.cell}>
                      {item?.amount}
                    </div>
                    <div className={styles.cell}>
                      {getStatusName(item?.status)}
                    </div>
                    <div className={styles.lastCell}>
                      <ButtonDD
                        items={[{
                          itemContent: (
                            <div className={'d-flex align-items-center justify-content-between'}>
                              <PopupPreviewDocument
                                allowHandlePreviewDocument={false}
                                documentPath={item?.url?.origin}
                              />
                              <ButtonAction
                                variant={'icon'}
                                iconButtonType={'primary'}
                                label={<img src={toAbsoluteUrl('/media/common/Download_primary.svg')} alt="download"
                                            className='w-20px h-20px'/>}
                                onClick={() => downloadFile(item.url.origin)}
                                customClassnames={'mx-2'}
                              />
                              {getDocumentTypeData(item.type, item.id).createFromDocumentItemsList}
                            </div>
                          )
                        }]}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Unit>
          )
          : <Empty customContainerClassname={styles.emptyContainer}/>
        }
      </div>
    </TextSuggestionsProvider>
  );
};

export default TabDocuments;